// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";

export default function CompanyPage() {
  return (
    <main>
      <section className="page-hero ground" data-en="COMPANY">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>会社概要</span>
          </nav>
          <h1 className="page-title">
            会社概要<strong>Company</strong>
          </h1>
        </div>
      </section>
      <section className="section company-sec">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            会社情報<strong>Profile</strong>
          </h2>
          <div className="company-panel">
            <table className="company-table">
              <tr>
                <th>会社名</th>
                <td>株式会社LEAPS（LEAPS Inc.）</td>
              </tr>
              <tr>
                <th>設立</th>
                <td>2023年5月</td>
              </tr>
              <tr>
                <th>代表者</th>
                <td>代表取締役　塩原 洋平</td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>
                  AIインテグレーション
                  <br />
                  ブロックチェーン事業開発
                </td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>
                  〒101-0051
                  <br />
                  東京都千代田区神田神保町1-41
                  <br />
                  <a
                    className="map-link"
                    href="https://www.google.com/maps/search/?api=1&query=東京都千代田区神田神保町1-41"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Google マップで見る ↗
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
